// Virasat: enquiry forms inside [data-v-whatsapp] open WhatsApp with the message ready to send.
// The form still posts to Shopify as usual, so a copy of every enquiry also arrives by email.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const box = form.closest('[data-v-whatsapp]');
  const number = (box?.getAttribute('data-v-whatsapp') || '').replace(/\D/g, '');
  if (!box || !number) return;

  const lines = [];
  const title = box.getAttribute('data-v-wa-title');
  if (title) lines.push(`*${title}*`);

  for (const field of form.querySelectorAll('label')) {
    const control = field.querySelector('input, textarea, select');
    if (!control) continue;
    const value =
      control instanceof HTMLSelectElement ? control.selectedOptions[0]?.textContent?.trim() : control.value.trim();
    if (!value) continue;
    const label = [...field.childNodes]
      .filter((node) => node.nodeType === Node.TEXT_NODE)
      .map((node) => node.textContent)
      .join(' ')
      .trim()
      .replace(/\s*\(.*\)$/, '');
    lines.push(control instanceof HTMLTextAreaElement ? `${label}:\n${value}` : `${label}: ${value}`);
  }

  window.open(`https://wa.me/${number}?text=${encodeURIComponent(lines.join('\n'))}`, '_blank', 'noopener');
});
